import apiClient from '../../../services/api'; // <-- Import client tập trung

const AUTH_ENDPOINT = '/auth';

const login = async (credentials) => {
  // Khi đăng nhập thành công, backend sẽ tự set cookie vào trình duyệt
  const response = await apiClient.post(`${AUTH_ENDPOINT}/login`, credentials);
  // Chỉ cần trả về dữ liệu người dùng
  return response.data;
};

const register = async (userData) => {
  const response = await apiClient.post(`${AUTH_ENDPOINT}/register`, userData);
  return response.data;
};

const logout = async () => {
  // Gọi API để backend xóa cookie
  const response = await apiClient.post(`${AUTH_ENDPOINT}/logout`);
  return response.data;
};

const forgotPassword = async (email) => {
  const response = await apiClient.post(`${AUTH_ENDPOINT}/forgot-password`, { email });
  return response.data;
};

const resetPassword = async (data) => {
  const response = await apiClient.post(`${AUTH_ENDPOINT}/reset-password`, data);
  return response.data;
};

const refreshToken = async () => {
  const response = await apiClient.post(`${AUTH_ENDPOINT}/refresh-token`);
  return response.data;
};

const verifyResetOtp = async (data) => {
  const response = await apiClient.post(`${AUTH_ENDPOINT}/verify-reset-otp`, data);
  return response.data;
};

export const authService = {
  login,
  register,
  logout,
  forgotPassword,
  verifyResetOtp,
  resetPassword,
  refreshToken
};
